module.exports = __webpack_public_path__ + "img/g-pay.9372a63b.svg";